<ng-container *ngIf="formControlName">
      <p-treeSelect
        [name]="formControlName"
        [(ngModel)]="selectedNodes"
        [options]="locationsArray$ | async"
        [metaKeySelection]="false"
        placeholder="Odaberite lokaciju"
        [filter]="true"
        [filterInputAutoFocus]="true"
        (onNodeSelect)="onNodeSelect($event)"
        (onClear)="clearSelection()"
        [showClear]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="30"
        [virtualScrollOptions]="{scrollHeight: '240px'}"
      ></p-treeSelect>
</ng-container>